import React from 'react';
import { getCardImage, hasCardImage } from '../utils/cardImages';
import CupsCardLayout from './CupsCardLayout';

const TarotCard = ({ card, isReversed = false, position = null, onClick = null, testId = null }) => {
  const cardImage = getCardImage(card.id);
  const hasImage = hasCardImage(card.id);
  
  // Check if it's a Cups number card (Ace through Ten)
  const isCupsNumberCard = card.suit === 'cups' && card.number >= 1 && card.number <= 10;
  
  // Hide symbols if card has custom image or cup layout
  const hasCustomArtwork = hasImage || isCupsNumberCard;

  return (
    <div 
      className={`tarot-card ${isReversed ? 'reversed' : ''}`}
      data-suit={card.suit}
      data-arcana={card.arcana}
      data-testid={testId}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {/* Card Image (if available) */}
      {hasImage && (
        <div 
          className="tarot-card-image" 
          style={{ backgroundImage: `url(${cardImage})` }}
        />
      )}
      
      {/* Cups Number Card Layout (if applicable) */}
      {!hasImage && isCupsNumberCard && (
        <CupsCardLayout number={card.number} />
      )}
      
      {/* Decorative corners */}
      <div className="tarot-card-corner top-left"></div>
      <div className="tarot-card-corner bottom-right"></div>
      <div className="tarot-card-corner top-right"></div>
      <div className="tarot-card-corner bottom-left"></div>
      <div className="tarot-card-pattern"></div>
      
      {/* Card content */}
      <div className={`tarot-card-inner ${hasCustomArtwork ? 'has-image' : ''}`}>
        <div className="card-symbol">{card.image_symbol}</div>
        <div className="card-divider"></div>
        <div className="card-name">{card.name}</div>
        <div className="crypto-name">{card.crypto_name}</div>
        {position && (
          <p style={{fontSize: '0.8rem', marginTop: '0.5rem', color: '#f59e0b', fontWeight: '600', textAlign: 'center'}}>
            {position}
          </p>
        )}
      </div>
    </div>
  );
};

export default TarotCard;
